import { camelize } from "humps";
import { AccessLevel, PermissionsGroup, Profile } from "PFTypes";

export const isProfileFieldPermitted = (
  permissionsGroup: PermissionsGroup | undefined,
  targetGroupId: number | undefined,
  fieldName: string,
  accessLevel = AccessLevel.ReadOnly
) => {
  if (!targetGroupId) {
    return false;
  }

  const profileFields = permissionsGroup?.crossGroupPermissions?.[targetGroupId]?.profileFieldsAccessLevels;
  if (!profileFields) {
    return false;
  }

  const perm = profileFields[camelize(fieldName)];

  if (accessLevel === AccessLevel.ReadWrite) {
    return perm === AccessLevel.ReadWrite;
  } else if (accessLevel === AccessLevel.ReadOnly) {
    return perm === AccessLevel.ReadOnly || perm === AccessLevel.ReadWrite;
  }

  return false;
};

export const getProfileCustomTypesAccessLevel = (
  permissionsGroup: PermissionsGroup | undefined,
  profile: Profile
): Record<string, AccessLevel> => {
  const targetPG = profile.permissionsGroup;

  return permissionsGroup?.crossGroupPermissions?.[targetPG.id]?.profileFieldsAccessLevels || {};
};
